var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_Development-1",
    "data-name": "Web Development-1",
    transform: "translate(-600 -181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 32,
    height: 32,
    transform: "translate(600 181)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "web-development_1_",
    "data-name": "web-development (1)",
    transform: "translate(601.205 181.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M29.59,7.935V3.6a2.6,2.6,0,0,0-2.6-2.6H2.6A2.6,2.6,0,0,0,0,3.6V7.935ZM20,4.468h5.2a.867.867,0,1,1,0,1.734H20a.867.867,0,0,1,0-1.734Zm-8.669,0a.867.867,0,1,1-.867.867A.867.867,0,0,1,11.327,4.468Zm-3.468,0a.867.867,0,1,1-.867.867A.867.867,0,0,1,7.86,4.468Zm-3.468,0a.867.867,0,1,1-.867.867A.867.867,0,0,1,4.392,4.468Z",
    fill: "#5a52f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M0,151v18.2a2.6,2.6,0,0,0,2.6,2.6H26.989a2.6,2.6,0,0,0,2.6-2.6V151Zm10.135,12.326a.867.867,0,1,1-1.083,1.354l-4.334-3.468a.867.867,0,0,1,0-1.354l4.334-3.468a.867.867,0,1,1,1.083,1.354l-3.488,2.791Zm8.057-8.517-5.2,12.136a.867.867,0,0,1-1.594-.683l5.2-12.136a.867.867,0,0,1,1.594.683Zm6.68,6.4-4.334,3.468a.867.867,0,1,1-1.083-1.354l3.488-2.791-3.488-2.791a.867.867,0,1,1,1.083-1.354l4.334,3.468A.867.867,0,0,1,24.872,161.213Z",
    transform: "translate(0 -141.331)",
    fill: "#5a52f9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopment);
export default __webpack_public_path__ + "static/media/Web_Development.cbf75c872206c80c9d11eca8a22eeb93.svg";
export { ForwardRef as ReactComponent };